import { updateCategory } from "./knowledgeCenterPage";

updateCategory("faq__tabWapper");

/**
 * Opens the nearest FAQ Dialog.
 * @param {string} trigger Custom class trigger Eg:"faq-dialog"
 * @returns {string} - Opens the nearby dialog
 */
export function openFaqDialog(trigger) {
    const wrapper = trigger.parentElement;
    if (!wrapper) return;

    const dialog = wrapper.querySelector("dialog");
    if (!dialog || typeof dialog.showModal !== "function") return;

    if (!dialog.open) {
        dialog.showModal();
    }

    const scrollContainer = dialog.querySelector("div");
    const closeBtn = dialog.querySelector("span.absolute");

    if (scrollContainer) {
        scrollContainer.scroll({ top: 0 });
    } else {
        dialog.scroll({ top: 0 });
    }

    if (closeBtn) {
        closeBtn.addEventListener(
            "click",
            () => {
                dialog.close();
            },
            { once: true }
        );
    }
}

/**
 * Initializes FAQ Dialog Triggers for "faq-dialog" classes
 * @param {string} scope Gets the current Document
 * @returns Initializes FAQ Dialog Triggers for all classes with "faq-dialog"
 */
export function initFaqDialogs(scope = document) {
    const triggers = scope.querySelectorAll(".faq-dialog");

    triggers.forEach((trigger) => {
        if (trigger.dataset.faqDialogAvailable === "true") return;

        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            openFaqDialog(trigger);
        });

        trigger.dataset.faqDialogAvailable = "true";
    });
}

document.addEventListener("DOMContentLoaded", () => {
    initFaqDialogs();
});